/* WS Jewelry — microanimations (pairs with ws-motion.css). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll progress hairline + header state
  const bar = document.createElement('div');
  bar.className = 'ws-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--ws-progress', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
      document.body.classList.toggle('ws-scrolled', window.scrollY > 40);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ws-in');
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
  );

  // Wrap each word of a heading so it can rise into view
  const splitWords = (el) => {
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          if (!child.textContent.trim()) return;
          const frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            const word = document.createElement('span');
            word.className = 'ws-word';
            const inner = document.createElement('span');
            inner.style.setProperty('--i', i++);
            inner.textContent = part;
            word.appendChild(inner);
            frag.appendChild(word);
          });
          child.replaceWith(frag);
        } else if (child.nodeType === Node.ELEMENT_NODE && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
    el.classList.add('ws-split');
    el.setAttribute('aria-label', el.textContent.trim());
  };

  const init = (root) => {
    if (!reduce) {
      root
        .querySelectorAll('h2.title:not([data-ws]), .banner__heading:not([data-ws]), .image-with-text__heading:not([data-ws])')
        .forEach((el) => {
          el.dataset.ws = '';
          splitWords(el);
          if (el.matches('h2.title')) el.classList.add('ws-rule');
          io.observe(el);
        });

      root.querySelectorAll('.image-with-text__media:not([data-ws])').forEach((el) => {
        el.dataset.ws = '';
        el.classList.add('ws-reveal');
        // Watch the unclipped wrapper: a fully clipped element never reports as visible
        io.observe(el.parentElement);
      });
    }

    // Sparkles on product cards that flip to the black shot
    root.querySelectorAll('.card-wrapper .card__media:not([data-ws])').forEach((media) => {
      media.dataset.ws = '';
      if (reduce || !media.querySelector('img + img')) return;
      [
        [18, 22],
        [74, 30],
        [60, 72],
      ].forEach(([x, y]) => {
        const s = document.createElement('span');
        s.className = 'ws-sparkle';
        s.setAttribute('aria-hidden', 'true');
        s.style.left = `${x}%`;
        s.style.top = `${y}%`;
        media.appendChild(s);
      });
    });
  };

  // Header logo: give its wrapper the shine, masked to the logo's own shape
  document.querySelectorAll('.header__heading-logo').forEach((img) => {
    const wrap = img.parentElement;
    const set = () => wrap.style.setProperty('--ws-logo', `url("${img.currentSrc || img.src}")`);
    wrap.classList.add('ws-logo-shine');
    set();
    img.addEventListener('load', set);
  });

  init(document);

  // Dawn re-renders sections (filters, theme editor) — pick up new nodes
  let pending = null;
  new MutationObserver(() => {
    clearTimeout(pending);
    pending = setTimeout(() => init(document), 120);
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
